//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const PatientScreeningList = createAsyncThunk(
  "PatientScreeningList",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingPatientScreeningList(""));
      const response = await UsePortalApi(
        `/Patient/PatientScreeningList`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingPatientScreeningListSuccess(response[0].entry)) : dispatch(gettingPatientScreeningListClear())

      } else {
        dispatch(
          gettingPatientScreeningListFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingPatientScreeningListFailed(error));
    }
  }
);

const PatientScreeningListSlice = createSlice({
  name: "PatientScreeningList",
  initialState: {
    ServiceTemplate: null,
    isServiceTemplate: false,
    errorServiceTemplate: false,
  },
  reducers: {
    gettingPatientScreeningList: (state, action) => {
      state.ServiceTemplate = null;
      state.isServiceTemplate = true;
      state.errorServiceTemplate = false;
    },
    gettingPatientScreeningListSuccess: (state, action) => {
      state.ServiceTemplate = action.payload;
      state.isServiceTemplate = false;
      state.errorServiceTemplate = false;
    },
    gettingPatientScreeningListFailed: (state, action) => {
      state.ServiceTemplate = null;
      state.isServiceTemplate = false;
      state.errorServiceTemplate = true;
    },
    gettingPatientScreeningListClear: (state, action) => {
      state.ServiceTemplate = null;
      state.isServiceTemplate = false;
      state.errorServiceTemplate = false;
    },
  },
});
export const {
  gettingPatientScreeningList,
  gettingPatientScreeningListSuccess,
  gettingPatientScreeningListFailed,
  gettingPatientScreeningListClear,
} = PatientScreeningListSlice.actions;
export default PatientScreeningListSlice.reducer;
